import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'

import { ListCell } from './cells'
import { FlagsCell } from '@src/routes/members/components/list/flags-cell'
import { MenuButton } from '@src/elements/button/button'
import { Popover } from '@src/components/popover/popover'
import { OptionGroup } from '@src/elements/select/option-group'

@Component({
  computed: {
    expandedMemberIndex () {
      return this.$store.state.expandedMemberIndex
    }
  }
})
export class ListBody extends Vue {

  @Prop({ required: true })
  items: Array<any>

  @Prop({ required: true })
  cells: { [key: string]: ListCell }

  expandedMemberIndex: number

  @Prop({ required: false, default: null })
  options: { label: string, onClickCallback: (item) => void }[]

  render (h: CreateElement) {
    return (<div class='body'>
      {this.items.map((item, index) => {
        return <div class='row-wrapper'>
          <div class='row'>
            {Object.entries(this.cells).map(([name, cell]) => {
              return h(cell, { props: { name, item, itemIndex: index } })
            })}
            {item.activityStatus === 'planned' && item.showOptions ?
              (<div class='activities-actions-wrapper'>
                <MenuButton>
                  <Popover>
                    <OptionGroup>
                      {this.options.map(({ label, onClickCallback }) => (
                        <div
                          onClick={() => onClickCallback(item)}>
                          {label}
                        </div>
                        ))
                      }
                    </OptionGroup>
                  </Popover>
                </MenuButton>
              </div>)
              : item.activityStatus === 'completed' && item.showOptions ?
                (<div class='activities-actions-wrapper disabled'><MenuButton /></div>)
                : ''}
          </div>
          {this.expandedMemberIndex === index ? h(FlagsCell, { props: { name: 'retentionFlags', item } }) : ''}
        </div>
      })}
    </div>)
  }
}
